// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"1646bce2","306":"86b6d4ce","457":"86b6d4ce","787":"86b6d4ce","843":"e1a4877a"}[chunkId] + ".chunk.css";
};